module.exports = __webpack_public_path__ + "assets/img/man.057471c5.png";